import { FC } from 'react'
import { styled } from '../../lib/stitches'

const StyledHiddenField = styled('input', {
  opacity: 0,
  position: 'absolute',
  top: 0,
  left: 0,
  height: 0,
  width: 0,
  zIndex: -1
})

export interface IHoneyPotFields {
  firstName: string
  lastName: string
}

interface Props {
  honeyPotFields: IHoneyPotFields
  handleHoneyPotChange: (honeyPotFields: IHoneyPotFields) => void
}

export const HoneyPotFields: FC<Props> = (props) => {
  const handleHoneyPotChange = ({ firstName = '', lastName = '' }: Partial<IHoneyPotFields>) => {
    props.handleHoneyPotChange({ firstName, lastName })
  }

  return (
    <>
      <StyledHiddenField
        type="text"
        name="firstName"
        value={props.honeyPotFields.firstName}
        onChange={(e) => handleHoneyPotChange({ firstName: e.target.value })}
      />
      <StyledHiddenField
        type="text"
        name="lastName"
        value={props.honeyPotFields.lastName}
        onChange={(e) => handleHoneyPotChange({ lastName: e.target.value })}
      />
    </>
  )
}
